/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { sharedURLs, environment } from "@insticator/insticator-ui"; // iui-utils

/* --------------- UTILITIES : URLs --------------- */

// set host URL based on dynamic environment variable
let shutterStockUrl;
let shutterStockKey;
let unsplashUrl;
let unsplashKey;
let productAnalyticsUrl;

switch (environment) {
    case 'PRODUCTION':
        shutterStockUrl = 'https://api.shutterstock.com/v2/images/search';
        shutterStockKey = 'v2/YmNkY2ItZGEyZGItMTRlN2EtNjAyZDctYzllZTgtMjBkYTUvMjA4MDIzMzcxL2N1c3RvbWVyLzMvVjlDQmRRNHVJZEUwOVNER2Njc0N2TzhadS00SUVhVUpvUlFNMFRhbnNZR1pJYnMxLWFkNlFUMklmMXRVMjV5MkdvUXNHc0RSWklJZ2hMdHc2T1ZHOFVCZVNxVTFtMW12bTFqNVczQk5TT0FFUl9PYW1nRTJFcVdWekRLdm4yWWV4MGJsNXpfMHhJaDUtbDhwb0xKLTE0d1lPUHVVdkhidWNQd3Z0amdHRlVhWnhFOWpnanVzcE9XbFBzd2NHYWkxQkhtMEl1dThTcEVXZm44dmozTGVuQQ';
        unsplashUrl =  'https://api.unsplash.com/search/photos';
        unsplashKey =  'c576cd7364ce61348c2e72ba81182b4f818b93972ed075619fed67d3b9fbe85a';
        productAnalyticsUrl = 'https://product-analytics.insticator.com/v1';
        break;
    case 'LOCALHOST':
        shutterStockUrl = 'https://api-sandbox.shutterstock.com/v2/images/search';
        shutterStockKey = 'v2/Y2E3ZWEtNWE1NDEtZDMwMGEtMGVmMzktZmNkMjEtY2Q5NzUvMjA4MDIzMzcxL2N1c3RvbWVyLzMvXzlyZllaaVlmdlpNaUFBWC03bTlZTnp4UW1CQkZVRXFXVlZKUGpFN3dBSDVaRmFEWnpVUTRrRXptTll4SlAzeGJhSnBZU01vNTBwQ1FrS1FuZUtHOXpnOFVZYnVQVUsyOHk0WE1GWE5OSkpmZTQ5ZXE3aFJYd1RubWxWd2pPdVR4X3NSZ0RPc01KdlllRk5Lajk0c01ZZEVVN3VDUnVJQU5UaFJ0a3ZQYkxJSzBMNFlrQnhVWC03T2RycFpGc09fRzBDOHVsSG04RHNRSW5QdTlUbXBYQQ';
        unsplashUrl =  'https://api.unsplash.com/search/photos';
        unsplashKey =  'c576cd7364ce61348c2e72ba81182b4f818b93972ed075619fed67d3b9fbe85a';
        break;
    case 'REVIEW':
        // fall through
    case 'BETA':
        // fall through
    case 'STAGING':
        // fall through
    default:
        shutterStockUrl = 'https://api-sandbox.shutterstock.com/v2/images/search';
        shutterStockKey = 'v2/Y2E3ZWEtNWE1NDEtZDMwMGEtMGVmMzktZmNkMjEtY2Q5NzUvMjA4MDIzMzcxL2N1c3RvbWVyLzMvXzlyZllaaVlmdlpNaUFBWC03bTlZTnp4UW1CQkZVRXFXVlZKUGpFN3dBSDVaRmFEWnpVUTRrRXptTll4SlAzeGJhSnBZU01vNTBwQ1FrS1FuZUtHOXpnOFVZYnVQVUsyOHk0WE1GWE5OSkpmZTQ5ZXE3aFJYd1RubWxWd2pPdVR4X3NSZ0RPc01KdlllRk5Lajk0c01ZZEVVN3VDUnVJQU5UaFJ0a3ZQYkxJSzBMNFlrQnhVWC03T2RycFpGc09fRzBDOHVsSG04RHNRSW5QdTlUbXBYQQ';
        unsplashUrl =  'https://api.unsplash.com/search/photos';
        unsplashKey =  'c576cd7364ce61348c2e72ba81182b4f818b93972ed075619fed67d3b9fbe85a';
        productAnalyticsUrl = 'https://product-analytics.hunchme.com/v1'
        break;
}

/* --------------- UTILITIES : URLs --------------- */

// store URLs for export
let url = {
    ...sharedURLs,

    // Extend urls list
    // Publisher Portal specific URLs
    image: `${sharedURLs.static.files.images}/publisherportal`,

    // Third party integrations
    giphy: {
        search: 'https://api.giphy.com/v1/gifs/search?api_key=7Z900XNNUvlLNKVTENIREXqhJJLKlYob&limit=40&rating=G&lang=en&q=',
        default:'https://api.giphy.com/v1/gifs/trending?api_key=7Z900XNNUvlLNKVTENIREXqhJJLKlYob&limit=40&rating=G&lang=en'
    },
    shutterStock: {
        search: `${shutterStockUrl}?license=editorial&per_page=40`,
        headers: { 'Authorization': `Bearer ${shutterStockKey}`}
    },
    unsplash: {
        search: `${unsplashUrl}?per_page=30`,
        headers: {'Authorization': `Client-ID ${unsplashKey}`,'Accept-Version': 'v1'}
    },

    productAnalyticsUrl: productAnalyticsUrl
};

/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export { url };
